// @flow
import * as React from 'react';
import { Icon } from '@ta/styleguide.icon';
import classnames from '@ta/common.classnames';
import styles from './TripModalCloseX.less';

type Props = {|
  className?: string,
  onClick?: (SyntheticEvent<HTMLDivElement>) => mixed,
|};

const TripModalCloseX = ({ className, onClick }: Props) => (
  <div className={classnames(className, styles.wrapper)} onClick={onClick}>
    <Icon name="times" />
  </div>
);

export default TripModalCloseX;
